// Official MTC brand assets.
//
//   - mtc-logo.png     <- https://www.mtc.com.na/assets/img/mtc_logo.png
//                         (MTC's own consumer wordmark, sourced directly off
//                         mtc.com.na)
//   - spectra-tower.png <- https://www.mtc.com.na/assets/img/spectra-tower.png
//                         (MTC's own illustration for the Spectra product
//                         line, used as the hero graphic on their Spectra
//                         business page)
//   - spectra-logo.png  <- supplied directly by the GRIDx team (official
//                         "MTC SPECTRA" wordmark)
//   - spectra-home-pricing-flyer.png <- supplied directly by the GRIDx team
//                         (official MTC Spectra Home Fibre pricing flyer —
//                         the 10/15/25/35/50/75 Mbps, 36-month prices on it
//                         match src/scenes/Main/networkproducts/data/
//                         mtcProducts.js exactly, corroborating that data)
import mtcLogo from "../assets/mtc-logo.png";
import spectraTower from "../assets/spectra-tower.png";
import spectraLogo from "../assets/spectra-logo.png";
import spectraPricingFlyer from "../assets/spectra-home-pricing-flyer.png";

export const brandAssets = {
  mtcLogo,
  spectraTower,
  spectraLogo,
  spectraPricingFlyer,
};
